import type { RoomsOperatingReport } from 'model/RoomsOperatingReport';

export const ROOMS_OPERATING_REPORT_GET_START = 'ROOMS_OPERATING_REPORT_GET_START';
export const ROOMS_OPERATING_REPORT_GET_SUCCESS = 'ROOMS_OPERATING_REPORT_GET_SUCCESS';
export const ROOMS_OPERATING_REPORT_GET_ERROR = 'ROOMS_OPERATING_REPORT_GET_ERROR';

export interface RoomsOperatingReportGetStart {
    type: typeof ROOMS_OPERATING_REPORT_GET_START;
}

export interface RoomsOperatingReportGetSuccess {
    type: typeof ROOMS_OPERATING_REPORT_GET_SUCCESS;
    payload: {
        report: RoomsOperatingReport;
    };
}

export interface RoomsOperatingReportGetError {
    type: typeof ROOMS_OPERATING_REPORT_GET_ERROR;
}

export type RoomsOperatingReportAction =
    | RoomsOperatingReportGetStart
    | RoomsOperatingReportGetSuccess
    | RoomsOperatingReportGetError;
